(() => {
    
    if (window.ucwHpPlusPopupInitialized) return;

    window.ucwHpPlusPopupInitialized = true;

    const getPopup = () => {
      return document.querySelector('[data-hp-plus-popup]');
    };

    let previousFocus = null;
    let previousOverflow = '';
    const openPopup = (button) => {
      const popup = getPopup();

      if (!popup) return;

      if (!popup.hidden) return;
      previousFocus = button;
      previousOverflow = document.body.style.overflow;
      popup.hidden = false;
      document.body.style.overflow = 'hidden';

      const closeButton = popup.querySelector('.uw-hp-plus-popup__close');

      if (closeButton) {
        closeButton.focus();
      }
    };

    const closePopup = () => {
      const popup = getPopup();

      if (!popup) return;

      popup.hidden = true;
      document.body.style.overflow = previousOverflow;
      if (previousFocus?.isConnected) previousFocus.focus();
      previousFocus = null;
    };

    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-hp-plus-popup-open]');

      if (openButton) {
        event.preventDefault();
        openPopup(openButton);
        return;
      }

      const closeButton = event.target.closest('[data-hp-plus-popup-close]');

      if (closeButton) {
        event.preventDefault();
        closePopup();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' && event.key !== 'Tab') return;

      const popup = getPopup();

      if (popup && !popup.hidden) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closePopup();
        } else {
          const controls = Array.from(popup.querySelectorAll('button:not([disabled]), a[href]')).filter((element) => element.getClientRects().length);
          const first = controls[0];
          const last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
        }
      }
    });
  })();
